import React from "react";
import { Button } from "../design/button";
import { PrinterIcon } from "@heroicons/react/16/solid";
import { File } from "../models/File";
import { FileService } from "../services/FileService";

interface DownloadFileButtonProps {
  file: File;
}

const DownloadFileButton: React.FC<DownloadFileButtonProps> = ({ file }) => {
  const [isDownloading, setIsDownloading] = React.useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const downloadUrl = await FileService.getDownloadURL(file._id);
      window.open(downloadUrl, "_blank");
    } catch (error) {
      alert("Failed to download file. Please try again later.");
    }
    setIsDownloading(false);
  };

  return (
    <Button
      onClick={handleDownload}
      disabled={isDownloading}
      className="flex items-center gap-2"
    >
      {isDownloading ? "..." : <PrinterIcon className="w-4 h-4" />}
    </Button>
  );
};

export default DownloadFileButton;
